/** Persistent WhatsApp shortcut for the global header: open the workspace, or start a new message via the existing composer. */
import { Link } from "react-router-dom";
import { MessageCircle, Plus } from "lucide-react";
import { openWaComposer } from "./WaComposer";

export const WA_HOME = "/admin/integrations/whatsapp";

export function WaHeaderShortcut() {
  return (
    <div className="hidden md:inline-flex items-stretch shrink-0 rounded-full border border-emerald-600/60 bg-white overflow-hidden" data-testid="header-whatsapp">
      <Link to={WA_HOME} data-testid="header-whatsapp-link" title="WhatsApp — messages, ready templates, scheduled"
        className="h-9 pl-2.5 pr-2.5 md:pr-3 inline-flex items-center gap-1.5 text-[12px] font-semibold text-emerald-700 hover:bg-emerald-50 transition-colors">
        <MessageCircle className="h-4 w-4" strokeWidth={2} aria-hidden="true" /><span className="hidden xl:inline">WhatsApp</span>
      </Link>
      <button type="button" onClick={() => openWaComposer({})} data-testid="header-whatsapp-new" title="New WhatsApp message" aria-label="New WhatsApp message"
        className="hidden sm:inline-flex h-9 px-2 lg:px-2.5 items-center gap-1 border-l border-emerald-600/40 bg-emerald-600 text-white text-[12px] font-semibold hover:bg-emerald-700 transition-colors">
        <Plus className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" /><span className="hidden 2xl:inline whitespace-nowrap">New message</span>
      </button>
    </div>
  );
}
